export default class Param {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
    get dto() {
        return Promise.resolve({
            Name: this.name,
            Value: this.value
        });
    }
}
//# sourceMappingURL=param.js.map